// extracted by mini-css-extract-plugin
export var cardsSection = "InsurancePartner-module--cardsSection--GjXDP";
export var description = "InsurancePartner-module--description--ojE9R";
export var descriptionSection = "InsurancePartner-module--descriptionSection--mI5hN";
export var headerSection = "InsurancePartner-module--headerSection--VKiOK";
export var insurancePartnerWrapper = "InsurancePartner-module--insurancePartnerWrapper--YQ1Au";
export var title = "InsurancePartner-module--title--XWVNe";